import { useState } from "react";
import ClickAwayListener from "@mui/material/ClickAwayListener";

import { LevelEditModal } from "./LevelEditModal";
import CreateStudentLevelModal from "./CreateStudentLevelModal";
import DeleteLevelModal from "./DeleteLevelModal";

export const ClassMoreButton = ({
  setEditLevelId,
  levelId,
  editLevelId,
  levelName,
  groupedStudents,
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const handleCloseMenu = () => {
    setMenuOpen(false);
  };

  const handleToggleMenu = (event, levelId) => {
    setMenuOpen(true);
    setEditLevelId(levelId);
    setMenuPosition({ x: event.clientX, y: event.clientY });
  };

  const styles = {
    button: {
      background: "none",
      border: "none",
      cursor: "pointer",
      height: "20px",
      width: "20px",
    },
    menu: {
      position: "absolute",
      left: `${menuPosition.x}px`,
      top: `${menuPosition.y}px`,
      background: "#fff",
      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
      borderRadius: "5px",
      padding: "10px",
      zIndex: 1000,
    },
    menuItem: {
      padding: "8px 12px",
      cursor: "pointer",
      fontSize: "14px",
      color: "#333",
      borderBottom: "1px solid #eee",
    },
    menuItemLast: {
      padding: "8px 12px",
      cursor: "pointer",
      fontSize: "14px",
      color: "#333",
    },
  };

  return (
    <div>
      <button
        style={{
          ...styles.button,
          visibility: levelId === "unassigned" ? "hidden" : "visible",
        }}
        onClick={(event) => handleToggleMenu(event, levelId)}
      >
        <span style={{ fontWeight: 900, color: "#000000", fontSize: "20px" }}>
          ⋮
        </span>
      </button>
      {menuOpen && (
        <ClickAwayListener onClickAway={handleCloseMenu}>
          <div style={styles.menu}>
            <div
              style={styles.menuItem}
              onClick={() => {
                setIsEditModalOpen(true); // levelId와 기존 학급명을 전달
                handleCloseMenu();
              }}
            >
              학급명 변경
            </div>
            <div
              style={styles.menuItem}
              onClick={() => {
                setIsCreateModalOpen(true);
                handleCloseMenu();
              }}
            >
              학생 추가
            </div>
            <div
              style={styles.menuItemLast}
              onClick={() => {
                setIsDeleteModalOpen(true);
                handleCloseMenu();
              }}
            >
              학급 삭제
            </div>
          </div>
        </ClickAwayListener>
      )}

      {isEditModalOpen && (
        <LevelEditModal
          setIsEditModalOpen={setIsEditModalOpen}
          editLevelId={editLevelId}
          levelName={levelName}
        ></LevelEditModal>
      )}

      {isCreateModalOpen && (
        <CreateStudentLevelModal
          classStudents={groupedStudents[levelId].students}
          setIsCreateModalOpen={setIsCreateModalOpen}
          editLevelId={editLevelId}
          levelName={levelName}
        ></CreateStudentLevelModal>
      )}
      {isDeleteModalOpen && (
        <DeleteLevelModal
          levelId={levelId}
          levelName={levelName}
          setIsDeleteModalOpen={setIsDeleteModalOpen}
        ></DeleteLevelModal>
      )}
    </div>
  );
};

export default ClassMoreButton;
